import { ComponentWithAs, IconProps } from '@chakra-ui/react';

import {
  ICapability,
  ICapabilityDomainEnum,
  ICapabilityLevelEnum,
} from '@r-client/data/graphql-types';
import { hasUserAccess, TAccess } from '@r-client/shared/feature/auth';
import {
  BriefcaseIcon,
  BuildingIcon,
  HomeIcon,
  PeopleIcon,
  // PolicyDocIcon,
} from '@r-client/shared/ui/chakra-ui-icons';

export interface INavLink {
  name: string;
  subItem?: Array<INavLink>;
  icon?: ComponentWithAs<'svg', IconProps>;
  path?: string;
  access?: TAccess;
}

export const navMeta: Array<INavLink> = [
  { name: 'Dashboard', icon: HomeIcon, path: '/dashboard' },
  {
    name: 'Users',
    icon: PeopleIcon,
    path: '/users',
    access: {
      domain: ICapabilityDomainEnum.User,
    },
  },
  {
    name: 'Capital LP Dash',
    icon: PeopleIcon,
    path: '/capital-users',
    access: {
      domain: ICapabilityDomainEnum.Capital,
      level: ICapabilityLevelEnum.Support,
    },
  },
  {
    name: 'Offerings',
    icon: BuildingIcon,
    path: '/offerings',
    access: {
      domain: ICapabilityDomainEnum.Offering,
    },
  },
  {
    name: 'Escrow',
    icon: BriefcaseIcon,
    path: '/escrow',
    access: {
      domain: ICapabilityDomainEnum.Offering,
    },
  },
  // {
  //   name: 'Secondaries',
  //   icon: BriefcaseIcon,
  //   access: {
  //     domain: ICapabilityDomainEnum.Secondaries,
  //   },
  //   subItem: [
  //     {
  //       name: 'Trade Eligibility',
  //       path: '/secondaries/trade-eligibility',
  //     },
  //     {
  //       name: 'Sell Orders',
  //       path: '/secondaries/sell-orders',
  //     },
  //     {
  //       name: 'Buy Orders',
  //       path: '/secondaries/buy-orders',
  //     },
  //     {
  //       name: 'Transactions',
  //       path: '/secondaries/transactions',
  //     },
  //   ],
  // },
  // {
  //   name: 'Legal',
  //   icon: PolicyDocIcon,
  //   subItem: [
  //     {
  //       name: 'KYCAML Review',
  //       path: '/legal/kycaml',
  //     },
  //     {
  //       name: 'Custodial Review',
  //       path: '/legal/custodial',
  //     },
  //   ],
  // },
];

export const getAccessedNavMeta = (
  capabilities: ICapability[]
): Array<INavLink> => {
  const navLists: Array<INavLink> = [];
  navMeta.forEach((n) => {
    if (!n.subItem && (!n.access || hasUserAccess(n.access, capabilities))) {
      navLists.push(n);
    }
    if (n.subItem && (!n.access || hasUserAccess(n.access, capabilities))) {
      const subDomainAccess = n?.subItem?.filter(
        (s) => !s.access || hasUserAccess(s.access, capabilities)
      );
      if (subDomainAccess?.length) {
        navLists.push({ ...n, subItem: subDomainAccess });
      }
    }
  });

  return navLists;
};
